import React from "react";

export default function Logo({ mode = "dark" }) {
  const primary = mode === "light" ? "#ffffff" : "#0d1b3e";
  const gold = "#b8892b";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg width="30" height="30" viewBox="0 0 40 40" fill="none">
        <path d="M20 4 C13 4 8 9 8 16 C8 24 20 36 20 36 C20 36 32 24 32 16 C32 9 27 4 20 4 Z"
          stroke={primary} strokeWidth="1.6" fill="none" />
        <path d="M14 15 L20 12 L26 15 L20 18 Z" fill={gold} />
        <line x1="26" y1="15" x2="26" y2="20" stroke={gold} strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      <div className="leading-none">
        <div className="serif text-[19px] font-semibold tracking-tight" style={{ color: primary }}>
          France<span style={{ color: gold }}>Path</span>
        </div>
      </div>
    </div>
  );
}
